<template>
  <div>
      <popular-products-modal type="app-new" v-if="productCategories.length > 0" v-model="popularProducts" :products-categories="productCategories"></popular-products-modal>
      <v-data-table no-data-text="Нет блюд"
                    no-results-text="По заданному запросу ничего не найдено"
                    :headers="headers"
                    :items="popularProducts"
                    :options.sync="options"
                    :header-props="{sortIcon: 'icon-custom-arrow'}"
                    :footer-props="footerProps"
                    :loading="loading"
                    :items-per-page="-1"
                    loading-text="Загрузка блюд... Подождите пожалуйста"
      >
        <template v-slot:body="props">
          <draggable
              :list="props.items"
              @end="endDrag(props.items)"
              tag="tbody"
          >
            <tr
                v-for="(item, index) in props.items"
                :key="index"
            >
              <td>
                <v-icon
                    small
                    class="page__grab-icon"
                >
                  mdi-arrow-all
                </v-icon>
              </td>
              <td> {{ item.product.name }} </td>
              <td> {{ item.product.category.name }} </td>
              <td>
                <span v-for="tag in item.product.tags">{{ tag.name }}
                  {{ tag == item.product.tags[item.product.tags.length - 1] ? '' : ', ' }}
                </span>
              </td>
              <td> {{ item.product.price }} </td>
            </tr>
          </draggable>
        </template>
      </v-data-table>
  </div>
</template>

<script>
// @ is an alias to /src

import ProductService from "../../api/ProductService";
import PopularProductsModal from "@/components/PopularProductsModal";
import draggable  from 'vuedraggable'

export default {
  name: 'HomeIndex',
  components: {PopularProductsModal, draggable },
  data: () => ({
    options: {},
    footerProps: {
      itemsPerPageText: 'Блюд на страницу',
      pageText: '{0}-{1} из {2}',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [-1]
    },
    headers: [
      {
        width: '1%',
        sortable: false
      },
      {
        text: 'Блюдо',
        value: 'product.name',
      },
      {text: 'Категория', value: 'product.category.name'},
      {
        text: 'Теги',
        value: 'product.tag',
      },
      {
        text: 'Цена',
        value: 'product.price',
      },
    ],

    loading: true,
    productCategories: [],
    popularProducts: []
  }),
  mounted() {
      let data = {type: 'app-new'}
    ProductService.getPopularRelation(data).then(response => {
      this.popularProducts = response.data
      this.loading = false
      ProductService.listByCategory().then(response => {
        this.productCategories = response.data
      })
    })


  },
  watch: {},
  methods: {
    endDrag(items){
        let params = {items: items, type: 'app-new'}
      ProductService.updatePopularProductsSort(params).then(response => {
        this.productCategories = response.data
      })
    }
  },
}
</script>

<style lang="scss" scoped>
  .page__grab-icon{
    &:hover{
      cursor: move;
    }
  }
</style>
